import React, { useCallback, useContext, } from 'react'
import useReactRouter from 'use-react-router'
import { makeStyles, } from '@material-ui/styles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import ChildrenType from '@shapr/react-shared/types/Children'
import classNames from 'classnames'

import GlobalContext from '~/contexts/GlobalContext'
import localStorageConfig from '~/config/localStorageConfig'

const RootLayout = props => {
  const { children, } = props
  const classes = useStyles()
  const { history, } = useReactRouter()
  const { authToken, setGlobalContext, } = useContext(GlobalContext)

  const handleLogoutClick = useCallback(() => {
    localStorage.removeItem(localStorageConfig.authToken)
    setGlobalContext({ authToken: undefined, })
    history.push('/login')
  }, [authToken, setGlobalContext,])
  return (
    <div className={classes.root}>
      <header className={classes.header}>
        {!!authToken && (
          <Button onClick={handleLogoutClick} className={classes.logoutButton}>
            Logout
          </Button>
        )}
      </header>
      <Typography
        gutterBottom
        variant="h2"
        className={classNames(classes.title)}
      >
        Shapr Conciergerie
      </Typography>
      {children}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    height: 80,
  },
  title: {
    textAlign: 'center',
  },
  logoutButton: {
    alignSelf: 'flex-start',
    margin: 15,
    marginLeft: 'auto',
  },
  login: {
    maxWidth: 400,
    width: '100%',
  },
}))

RootLayout.propTypes = {
  children: ChildrenType.isRequired,
}

export default React.memo(RootLayout)
